import { render, staticRenderFns } from "./EmailBadge.vue?vue&type=template&id=f2b8c5da&"
import script from "./EmailBadge.vue?vue&type=script&lang=ts&"
export * from "./EmailBadge.vue?vue&type=script&lang=ts&"
import style0 from "./EmailBadge.vue?vue&type=style&index=0&id=f2b8c5da&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports